/* ============ line-art library ============ */
var S='stroke="#17150F" stroke-linecap="round" stroke-linejoin="round"';
var OUT=S+' stroke-width="4.5" fill="#FFFFFF" class="f"';
var LINE=S+' stroke-width="4" fill="none"';
var THIN=S+' stroke-width="3" fill="none"';
function ray(cx,cy,r1,r2,angs){return angs.map(function(a){var r=a*Math.PI/180;
 return '<line x1="'+(cx+Math.cos(r)*r1).toFixed(1)+'" y1="'+(cy+Math.sin(r)*r1).toFixed(1)+
 '" x2="'+(cx+Math.cos(r)*r2).toFixed(1)+'" y2="'+(cy+Math.sin(r)*r2).toFixed(1)+'" '+LINE+'/>';}).join('');}

var SCENES={
dragon:{label:'Dragons & castles',title:' DRAGON QUEST',tags:['fantasy'],art:
'<circle cx="512" cy="228" r="40" '+OUT+'/>'+ray(512,228,50,66,[0,45,90,135,180,225,270,315])+
'<path d="M108 232c-22 0-28 26-6 30h94c24-4 18-30-6-30-4-20-32-24-42-8-14-8-34-2-40 8Z" '+OUT+'/>'+
'<path d="M300 196c-16 0-20 18-4 21h66c17-3 13-21-4-21-3-14-22-17-30-6-9-6-24-1-28 6Z" '+OUT+'/>'+
'<rect x="340" y="404" width="56" height="216" rx="3" '+OUT+'/><rect x="496" y="404" width="56" height="216" rx="3" '+OUT+'/>'+
'<rect x="396" y="446" width="100" height="174" rx="3" '+OUT+'/>'+
'<path d="M330 404 368 342 406 404Z" '+OUT+'/><path d="M486 404 524 342 562 404Z" '+OUT+'/><path d="M388 446 446 392 504 446Z" '+OUT+'/>'+
'<line x1="368" y1="342" x2="368" y2="304" '+LINE+'/><path d="M368 306 404 318 368 330Z" '+OUT+'/>'+
'<line x1="524" y1="342" x2="524" y2="304" '+LINE+'/><path d="M524 306 560 318 524 330Z" '+OUT+'/>'+
'<path d="M420 620v-72a26 26 0 0 1 52 0v72Z" '+OUT+'/><line x1="446" y1="560" x2="446" y2="620" '+THIN+'/>'+
'<rect x="354" y="452" width="28" height="40" rx="14" '+OUT+'/><rect x="510" y="452" width="28" height="40" rx="14" '+OUT+'/>'+
'<path d="M164 502c-16-60 30-96 76-79-22 23-30 50-26 79Z" '+OUT+'/>'+
'<path d="M132 640c-50 10-70 42-62 72" '+LINE+'/><path d="M104 644 98 618 124 634Z" '+OUT+'/><path d="M78 674 68 652 94 656Z" '+OUT+'/>'+
'<ellipse cx="152" cy="660" rx="34" ry="16" '+OUT+'/><ellipse cx="232" cy="662" rx="32" ry="15" '+OUT+'/>'+
'<path d="M150 656c-45-6-58-64-32-108 24-40 87-46 122-18 42 33 32 100-8 124Z" '+OUT+'/>'+
'<path d="M174 640c-25-30-18-67 8-87 26-18 56-6 61 24 6 36-30 66-62 64Z" '+THIN+'/>'+
'<path d="M196 530c0-32 14-52 36-60l40 18c-18 20-24 36-26 54Z" '+OUT+'/>'+
'<ellipse cx="258" cy="452" rx="58" ry="50" '+OUT+'/>'+
'<path d="M306 458c30-10 50 2 50 16s-22 20-48 10Z" '+OUT+'/><circle cx="340" cy="466" r="4" fill="#17150F"/>'+
'<path d="M238 406 226 366 258 390Z" '+OUT+'/><path d="M278 400 292 362 302 394Z" '+OUT+'/>'+
'<circle cx="270" cy="438" r="9" fill="#17150F"/><circle cx="273" cy="435" r="3" fill="#FFFFFF"/>'+
'<path d="M244 478c10 8 26 8 36 0" '+THIN+'/>'+
'<path d="M20 694c120-26 200 14 320-8 110-20 180 18 240-4" '+LINE+'/>'+
'<path d="M60 700l-4-22M78 700l2-24M96 700l6-20" '+THIN+'/><path d="M470 706l-4-22M488 706l2-24M506 706l6-20" '+THIN+'/>'+
'<circle cx="382" cy="716" r="10" '+OUT+'/><circle cx="382" cy="696" r="9" '+OUT+'/><circle cx="401" cy="710" r="9" '+OUT+'/>'+
'<circle cx="394" cy="732" r="9" '+OUT+'/><circle cx="370" cy="732" r="9" '+OUT+'/><circle cx="363" cy="710" r="9" '+OUT+'/>'},

space:{label:'Rockets & planets',title:' SPACE MISSION',tags:['adventure'],art:
[[80,210],[520,330],[140,600],[470,640],[60,420],[540,190],[190,250]].map(function(p){var x=p[0],y=p[1];
 return '<path d="M'+x+' '+(y-16)+'L'+(x+5)+' '+(y-5)+'L'+(x+16)+' '+y+'L'+(x+5)+' '+(y+5)+'L'+x+' '+(y+16)+
 'L'+(x-5)+' '+(y+5)+'L'+(x-16)+' '+y+'L'+(x-5)+' '+(y-5)+'Z" '+OUT+'/>';}).join('')+
[[110,320],[430,240],[95,520],[510,540],[250,205],[560,430]].map(function(p){
 return '<circle cx="'+p[0]+'" cy="'+p[1]+'" r="5" fill="#17150F"/>';}).join('')+
'<circle cx="132" cy="286" r="58" '+OUT+'/><ellipse cx="132" cy="286" rx="96" ry="24" '+LINE+' transform="rotate(-18 132 286)"/>'+
'<circle cx="112" cy="268" r="12" '+OUT+'/><circle cx="150" cy="302" r="9" '+OUT+'/>'+
'<circle cx="486" cy="248" r="46" '+OUT+'/><circle cx="470" cy="234" r="11" '+OUT+'/><circle cx="500" cy="262" r="8" '+OUT+'/><circle cx="496" cy="228" r="6" '+OUT+'/>'+
'<path d="M300 336c42 42 58 132 52 226H248c-6-94 10-184 52-226Z" '+OUT+'/>'+
'<path d="M262 424c22-22 54-22 76 0" '+THIN+'/><path d="M250 508h100" '+THIN+'/>'+
'<circle cx="300" cy="456" r="32" '+OUT+'/><circle cx="300" cy="456" r="21" '+THIN+'/>'+
'<path d="M250 502 202 596l48-26Z" '+OUT+'/><path d="M350 502l48 94-48-26Z" '+OUT+'/>'+
'<rect x="262" y="562" width="76" height="26" rx="9" '+OUT+'/>'+
'<path d="M272 590c-4 44 20 54 28 88 12-34 34-44 30-88Z" '+OUT+'/><path d="M288 594c-2 30 10 42 12 60 6-18 18-30 16-60Z" '+THIN+'/>'+
'<ellipse cx="510" cy="690" rx="52" ry="26" '+OUT+'/><circle cx="496" cy="684" r="8" '+THIN+'/><circle cx="522" cy="696" r="6" '+THIN+'/>'+
'<ellipse cx="96" cy="700" rx="38" ry="20" '+OUT+'/><circle cx="88" cy="696" r="6" '+THIN+'/>'},

sea:{label:'Under the sea',title:' OCEAN ADVENTURE',tags:['animals','adventure'],art:
'<path d="M20 200c40-24 60 24 100 0s60 24 100 0 60 24 100 0 60 24 100 0 60 24 100 0" '+LINE+'/>'+
'<path d="M20 236c40-24 60 24 100 0s60 24 100 0 60 24 100 0 60 24 100 0 60 24 100 0" '+THIN+'/>'+
[[110,320,14],[86,368,9],[470,300,16],[492,352,10],[300,286,12],[540,412,8]].map(function(p){
 return '<circle cx="'+p[0]+'" cy="'+p[1]+'" r="'+p[2]+'" '+OUT+'/>';}).join('')+
'<path d="M244 448c46-52 152-52 194 6-42 56-148 56-194 6Z" '+OUT+'/><path d="M244 452 184 404l6 96Z" '+OUT+'/>'+
'<path d="M312 400c14-26 40-30 54-14-18 4-30 12-38 26Z" '+OUT+'/>'+
'<circle cx="392" cy="440" r="9" fill="#17150F"/><circle cx="395" cy="437" r="3" fill="#FFFFFF"/>'+
'<path d="M404 470c10 8 22 8 30 2" '+THIN+'/><path d="M290 424c10 22 10 40 2 62M320 416c12 24 12 46 2 70" '+THIN+'/>'+
'<path d="M120 396c26-30 84-30 108 4-24 32-82 32-108 4Z" '+OUT+'/><path d="M120 400 84 372l4 56Z" '+OUT+'/>'+
'<circle cx="204" cy="394" r="6" fill="#17150F"/><path d="M150 384c6 14 6 24 2 38" '+THIN+'/>'+
'<path d="M124 592c0-38 58-38 58 0 0 24-58 24-58 0Z" '+OUT+'/><ellipse cx="153" cy="566" rx="34" ry="30" '+OUT+'/>'+
'<circle cx="142" cy="562" r="6" fill="#17150F"/><circle cx="165" cy="562" r="6" fill="#17150F"/>'+
'<path d="M146 580c5 5 12 5 16 0" '+THIN+'/>'+
'<path d="M126 596c-16 18-8 44 6 56M140 600c-10 24-2 46 10 56M158 602c4 24 14 40 30 46M174 596c14 14 24 34 20 54" '+LINE+'/>'+
'<path d="M492 704c-6-52 14-70 6-110-6-32 12-46 24-52" '+LINE+'/><path d="M528 706c-4-44 10-60 4-92" '+THIN+'/>'+
'<path d="M74 706c-6-46 12-64 6-98" '+LINE+'/>'+
'<rect x="236" y="618" width="132" height="72" rx="6" '+OUT+'/><path d="M236 618a66 30 0 0 1 132 0Z" '+OUT+'/>'+
'<rect x="288" y="620" width="28" height="34" rx="5" '+OUT+'/><circle cx="302" cy="638" r="5" fill="#17150F"/>'+
'<line x1="236" y1="652" x2="368" y2="652" '+THIN+'/>'+
'<path d="M20 706c60-18 110 12 170-4 70-18 120 14 190-2 60-14 110 8 186-6" '+LINE+'/>'+
'<path d="M410 730c0-14 12-24 26-24s26 10 26 24Z" '+OUT+'/><path d="M424 730c2-12 6-18 12-22M448 730c-2-12-6-18-12-22" '+THIN+'/>'},

jungle:{label:'Jungle safari',title:' JUNGLE SAFARI',tags:['animals'],art:
'<circle cx="508" cy="232" r="38" '+OUT+'/>'+ray(508,232,48,64,[0,60,120,180,240,300])+
'<path d="M78 700c14-100 6-180-6-236" '+LINE+'/><path d="M92 700c-12-98-4-176 6-232" '+LINE+'/>'+
'<path d="M72 464c-40-30-58-10-56 16 24-18 40-12 56-6Z" '+OUT+'/><path d="M72 462c-14-46-42-52-58-38 26 6 40 20 52 40Z" '+OUT+'/>'+
'<path d="M84 456c8-46 40-58 58-44-26 8-42 22-52 46Z" '+OUT+'/><path d="M92 468c40-28 62-8 58 18-24-18-42-14-58-8Z" '+OUT+'/>'+
'<path d="M540 706c-14-92-8-166 2-218" '+LINE+'/>'+
'<path d="M540 496c-36-24-52-6-50 16 22-16 36-10 50-6Z" '+OUT+'/><path d="M540 492c-12-42-38-46-52-34 24 6 36 18 46 36Z" '+OUT+'/>'+
'<path d="M550 488c8-42 36-52 52-40-24 8-38 20-48 42Z" '+OUT+'/><path d="M552 500c36-26 56-6 52 16-22-16-38-12-52-6Z" '+OUT+'/>'+
'<path d="M180 180c40 22 80 6 120 24s60 4 100 20" '+LINE+'/>'+
[[214,196],[268,202],[322,206],[376,214],[430,224]].map(function(p){
 return '<path d="M'+p[0]+' '+p[1]+'c-14 6-16 26 0 30s18-24 0-30Z" '+OUT+'/>';}).join('')+
'<circle cx="300" cy="452" r="94" '+OUT+'/>'+
Array.from({length:16},function(_,i){var a=i*22.5*Math.PI/180;
 return '<path d="M'+(300+Math.cos(a)*94).toFixed(1)+' '+(452+Math.sin(a)*94).toFixed(1)+
 'Q'+(300+Math.cos(a+0.19)*112).toFixed(1)+' '+(452+Math.sin(a+0.19)*112).toFixed(1)+
 ' '+(300+Math.cos(a)*124).toFixed(1)+' '+(452+Math.sin(a)*124).toFixed(1)+'" '+LINE+'/>';}).join('')+
'<circle cx="262" cy="436" r="10" fill="#17150F"/><circle cx="338" cy="436" r="10" fill="#17150F"/>'+
'<circle cx="266" cy="432" r="3.5" fill="#FFFFFF"/><circle cx="342" cy="432" r="3.5" fill="#FFFFFF"/>'+
'<path d="M284 474h32l-16 16Z" '+OUT+'/><ellipse cx="278" cy="500" rx="26" ry="20" '+OUT+'/><ellipse cx="322" cy="500" rx="26" ry="20" '+OUT+'/>'+
'<path d="M300 490v14" '+THIN+'/>'+
'<path d="M244 494c-22-6-36-2-46 6M244 508c-22 2-36 10-44 20M356 494c22-6 36-2 46 6M356 508c22 2 36 10 44 20" '+THIN+'/>'+
'<ellipse cx="228" cy="366" rx="22" ry="20" '+OUT+'/><ellipse cx="372" cy="366" rx="22" ry="20" '+OUT+'/>'+
'<path d="M238 566c-12 44-6 82 6 108M362 566c12 44 6 82-6 108" '+LINE+'/>'+
'<path d="M226 690c0-14 12-22 26-22s26 8 26 22Z" '+OUT+'/><path d="M322 690c0-14 12-22 26-22s26 8 26 22Z" '+OUT+'/>'+
'<path d="M18 700c110-22 190 14 300-6 100-18 170 16 264-4" '+LINE+'/>'+
'<path d="M150 712l-4-24M168 712l2-26M186 712l6-22" '+THIN+'/><path d="M420 716l-4-24M438 716l2-26M456 716l6-22" '+THIN+'/>'}
};
var THEME_KEYS=Object.keys(SCENES);

/* ============ page builder ============ */
function possessive(n){n=(n||'').trim()||'Your Kid';return /s$/i.test(n)?n+"'":n+"'s";}
function pageSVG(name,theme,opts){
  opts=opts||{};
  var t=(possessive(name)+SCENES[theme].title).toUpperCase();
  var fs=t.length>26?25:t.length>20?31:t.length>15?38:44;
  return '<svg viewBox="0 0 600 780" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Coloring page: '+t+'"'+
    (opts.anim?' class="drawing"':'')+'>'+
    '<rect x="12" y="12" width="576" height="756" rx="10" fill="#FFFFFF" stroke="#17150F" stroke-width="3"/>'+
    '<path d="M60 50H540L516 96 540 142H60L84 96Z" '+(opts.flat?S+' stroke-width="4.5" fill="#FFFFFF"':OUT)+'/>'+
    '<text x="300" y="97" text-anchor="middle" dominant-baseline="middle" font-family="Baloo 2,sans-serif" '+
    'font-weight="800" font-size="'+fs+'" fill="#17150F" letter-spacing="1.5" style="pointer-events:none">'+t+'</text>'+
    (opts.flat?SCENES[theme].art.replace(/class="f"/g,''):SCENES[theme].art)+
    '<text x="300" y="756" text-anchor="middle" font-family="Karla,sans-serif" font-size="15" fill="#B6AE9C" '+
    'letter-spacing="3" style="pointer-events:none">PAPER STAR</text></svg>';
}

/* ============ crayon engine ============ */
var CRAYONS=[['Red','#E8452C'],['Orange','#F58A2E'],['Yellow','#FFC53D'],['Green','#3E9B4F'],
             ['Blue','#2563D9'],['Pink','#FF8FA3'],['Purple','#7B5EA7'],['Erase','#FFFFFF']];

/* lighten (pct > 0) or darken (pct < 0) a hex colour */
function shade(hex, pct){
  var n = parseInt(hex.slice(1), 16), r = n>>16, g = (n>>8)&255, b = n&255;
  var f = function(c){
    return Math.max(0, Math.min(255, Math.round(pct < 0 ? c*(1+pct) : c + (255-c)*pct)));
  };
  return '#' + ((1<<24) + (f(r)<<16) + (f(g)<<8) + f(b)).toString(16).slice(1);
}

/* An actual crayon: sharpened tip, paper wrapper with two bands, waxy
   highlight down one side. Drawn rather than photographed so it picks up
   whatever colour it represents - including the white one for erasing. */
function crayonSVG(hex){
  var wax  = shade(hex, -0.22);   // exposed wax is deeper than the printed paper
  var tip  = shade(hex, -0.34);
  var band = shade(hex, -0.30);
  var ink  = '#17150F';
  // Order matters: the shine goes on the bare wax FIRST, then the paper
  // wrapper covers the middle of it. That is what stops it reading as a pencil.
  return '<svg viewBox="0 0 40 128" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
      '<g stroke="' + ink + '" stroke-width="3" stroke-linejoin="round" stroke-linecap="round">' +
        // blunt conical tip - crayons are never needle-sharp
        '<path d="M20 9 L31 42 H9 Z" fill="' + tip + '"/>' +
        // wax barrel
        '<rect x="9" y="40" width="22" height="80" rx="4" fill="' + wax + '"/>' +
      '</g>' +
      // shine on the bare wax only
      '<rect x="13.5" y="44" width="4" height="72" rx="2" fill="#fff" opacity=".38"/>' +
      // paper wrapper, wider than the barrel, hiding the middle of the shine
      '<g stroke="' + ink + '" stroke-width="3" stroke-linejoin="round">' +
        '<rect x="6" y="55" width="28" height="52" rx="2" fill="' + hex + '"/>' +
      '</g>' +
      // printed bands top and bottom of the wrapper
      '<rect x="7.5" y="58.5" width="25" height="6" fill="' + band + '"/>' +
      '<rect x="7.5" y="97.5" width="25" height="6" fill="' + band + '"/>' +
      // soft sheen across the paper, much fainter than the wax
      '<rect x="12" y="66" width="5" height="28" rx="2.5" fill="#fff" opacity=".2"/>' +
    '</svg>';
}

/* Build one crayon button. Shared by both studios so they never drift apart. */
function crayonButton(label, hex, selected, onPick){
  var b = document.createElement('button');
  b.type = 'button';
  b.className = 'crayon';
  b.title = label;
  b.setAttribute('aria-label', label === 'Erase' ? 'Erase' : label + ' crayon');
  b.setAttribute('aria-pressed', selected ? 'true' : 'false');
  b.innerHTML = crayonSVG(hex);
  b.onclick = function(){
    var row = b.parentNode;
    if(row) row.querySelectorAll('.crayon').forEach(function(x){ x.setAttribute('aria-pressed','false'); });
    b.setAttribute('aria-pressed','true');
    onPick(hex);
  };
  return b;
}
function Studio(sheetEl,crayonEl){
  var cur=CRAYONS[0][1];
  if(crayonEl && !crayonEl.dataset.built){
    crayonEl.dataset.built = '1';
    CRAYONS.forEach(function(c,i){
      crayonEl.appendChild(crayonButton(c[0], c[1], i===0, function(hex){ cur = hex; }));
    });
  }
  return {
    draw:function(name,theme){
      sheetEl.innerHTML=pageSVG(name,theme,{anim:true});
      var svg=sheetEl.querySelector('svg');
      [].slice.call(svg.children).forEach(function(c,i){c.style.animationDelay=(i*0.028)+'s';});
      svg.querySelectorAll('.f').forEach(function(p){
        p.addEventListener('click',function(){p.setAttribute('fill',cur);});
      });
    }
  };
}
function starRow(n){
  n=n||5;var out='';
  for(var i=0;i<5;i++){
    out+='<svg width="18" height="18" viewBox="0 0 20 20" fill="'+(i<n?'#FFC53D':'#FFFFFF')+
    '" stroke="#17150F" stroke-width="1.4" stroke-linejoin="round">'+
    '<path d="M10 1.5l2.6 5.3 5.9.9-4.2 4.1 1 5.8L10 14.9 4.7 17.6l1-5.8L1.5 7.7l5.9-.9Z"/></svg>';
  }
  return out;
}


/* ============ image studio ============
   Same interface as Studio, but colours real line-art images with a
   canvas flood fill. sources = { dragon: url, space: url, ... } */
function ImageStudio(sheetEl, crayonEl, sources){
  var cur = CRAYONS[0][1];
  if(crayonEl && !crayonEl.dataset.built){
    crayonEl.dataset.built = '1';
    CRAYONS.forEach(function(c,i){
      crayonEl.appendChild(crayonButton(c[0], c[1], i===0, function(hex){ cur = hex; }));
    });
  }

  sheetEl.classList.add('sheet--img');
  sheetEl.innerHTML = '<div class="img-banner"><span></span></div><canvas width="900" height="900" aria-label="Coloring page preview"></canvas>';
  var banner = sheetEl.querySelector('.img-banner span');
  var canvas = sheetEl.querySelector('canvas');
  var ctx = canvas.getContext('2d', { willReadFrequently: true });
  var W = 900, H = 900;
  var cache = {}, curTheme = null;

  function hexToRgb(h){
    return [parseInt(h.slice(1,3),16), parseInt(h.slice(3,5),16), parseInt(h.slice(5,7),16)];
  }

  function paint(img){
    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(0,0,W,H);
    ctx.drawImage(img, 0, 0, W, H);
    pixels = null; // the picture changed, so re-read it on the next colour
  }

  function show(theme, done){
    if(cache[theme]){ paint(cache[theme]); if(done) done(); return; }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function(){ cache[theme] = img; paint(img); if(done) done(); };
    img.src = sources[theme];
  }

  /* Scanline flood fill; dark pixels are barriers.

     Two things here exist to stop the tab running out of memory, because the
     white paper is one huge connected region of ~450,000 pixels:

       - one seed is pushed per contiguous RUN of neighbouring pixels, not per
         pixel. Per-pixel pushing put ~900,000 little [x,y] arrays on the heap
         for a single click - about 48MB a tap, which killed phones after a
         few colours.
       - `seen` marks every pixel we have settled, so no pixel is ever queued
         or examined twice however tangled the region is.

     The stack is a flat array of numbers (x, y, x, y, ...) rather than an
     array of pairs, so filling a whole page allocates almost nothing. */
  var pixels = null; // ImageData reused between clicks; refreshed on paint()

  function fill(sx, sy, rgb){
    if(!pixels){
      try { pixels = ctx.getImageData(0,0,W,H); }
      catch(e){ return; } /* canvas tainted (no CORS) - colouring off, preview still shows */
    }
    var d = pixels.data;

    var i0 = (sy*W+sx)*4;
    if(d[i0]+d[i0+1]+d[i0+2] < 300) return;              // clicked a line, not a gap
    var sr=d[i0], sg=d[i0+1], sb=d[i0+2];
    if(Math.abs(sr-rgb[0])+Math.abs(sg-rgb[1])+Math.abs(sb-rgb[2]) < 12) return; // already this colour

    function match(px){
      var i = px*4;
      if(d[i]+d[i+1]+d[i+2] < 300) return false;         // barrier
      return Math.abs(d[i]-sr)+Math.abs(d[i+1]-sg)+Math.abs(d[i+2]-sb) < 150;
    }

    var seen = new Uint8Array(W*H);
    var stack = [sx, sy];

    while(stack.length){
      var y = stack.pop(), x = stack.pop();
      var px = y*W+x;
      if(seen[px] || !match(px)) continue;

      var xl = x; while(xl > 0    && !seen[px-(x-xl)-1] && match(y*W+xl-1)) xl--;
      var xr = x; while(xr < W-1  && !seen[y*W+xr+1]    && match(y*W+xr+1)) xr++;

      for(var xi=xl; xi<=xr; xi++){
        var q = y*W+xi, i = q*4;
        seen[q] = 1;
        d[i]=rgb[0]; d[i+1]=rgb[1]; d[i+2]=rgb[2]; d[i+3]=255;
      }

      /* one seed per run above and below, instead of one per pixel */
      if(y > 0)   seedRow(xl, xr, y-1, seen, match, stack);
      if(y < H-1) seedRow(xl, xr, y+1, seen, match, stack);
    }

    ctx.putImageData(pixels,0,0);
  }

  function seedRow(xl, xr, y, seen, match, stack){
    var run = false;
    for(var x=xl; x<=xr; x++){
      var px = y*W+x;
      var okHere = !seen[px] && match(px);
      if(okHere && !run){ stack.push(x, y); run = true; }   // start of a new run
      else if(!okHere){ run = false; }
    }
  }

  canvas.addEventListener('click', function(e){
    var r = canvas.getBoundingClientRect();
    var x = Math.floor((e.clientX - r.left) / r.width  * W);
    var y = Math.floor((e.clientY - r.top)  / r.height * H);
    if(x<0||y<0||x>=W||y>=H) return;
    fill(x, y, hexToRgb(cur));
  });

  return {
    draw: function(name, theme){
      if(!sources[theme]) theme = 'dragon';
      /* No name means this is not a personalised book - a ready-made colouring
         pack, say - so title the page by its world instead of by a child. */
      banner.textContent = (name
        ? possessive(name) + SCENES[theme].title
        : SCENES[theme].label).toUpperCase();
      if(theme !== curTheme){ curTheme = theme; show(theme); }
    }
  };
}

/* ============ Shopify auto-render ============
   Any element with data-sl-page renders a coloring page.
   <div data-sl-page data-name="Sam" data-theme="dragon" data-flat="true"></div>
   Live elements (no data-flat) are colourable.                                  */
function renderKind(kind, name, theme, opts){
  opts = opts || {};
  if(kind === 'cover')    return coverSVG(name, theme, opts.age);
  if(kind === 'story')    return storySVG(name, theme, opts.page);
  if(kind === 'coloured') return colouredSVG(name, theme);
  return pageSVG(name, theme, opts);
}

function slRenderAll(root){
  (root||document).querySelectorAll('[data-sl-page]').forEach(function(el){
    if(el.dataset.slDone === '1' && !el.dataset.slLive) return;
    var name  = el.dataset.name || 'Sam';
    var theme = SCENES[el.dataset.theme] ? el.dataset.theme : 'dragon';
    var kind  = el.dataset.kind || 'line';
    var flat  = el.dataset.flat === 'true';
    el.innerHTML = renderKind(kind, name, theme,
      { flat: flat, anim: !flat && kind === 'line', age: el.dataset.age });
    el.dataset.slDone = '1';
    if(!flat && kind === 'line'){
      var svg = el.querySelector('svg');
      [].slice.call(svg.children).forEach(function(c,i){ c.style.animationDelay = (i*0.028)+'s'; });
    }
  });
}
document.addEventListener('DOMContentLoaded',function(){slRenderAll();});

/* ============================================================
   Covers, story pages and coloured-in pages.
   The coloring page shows what a child does. These show what
   they get — which is the thing people actually pay for.
   ============================================================ */

var COVERS = {
  dragon: { bg:'#FFC53D', tint:'#FFF3D4', title:'AND THE DRAGON',
    story:["|NAME| was not afraid of the dragon.",
           "The dragon, it turned out, was a",
           "little afraid of |NAME|."],
    spread:["|NAME| was not afraid of the dragon. The dragon, it turned out, was a little afraid of |NAME|.",
            "So they sat down on the hill together, which is how most friendships start, and watched the flags go small and far below."] },
  space:  { bg:'#1B2A5E', tint:'#E4E9F7', title:'GOES TO SPACE',
    story:["The rocket had one seat, and it was",
           "exactly |NAME|-sized.",
           "\u201cWhere to?\u201d asked the little robot."],
    spread:["The rocket had exactly one seat, and it was exactly |NAME|-sized. \u201cWhere to?\u201d asked the little robot.",
            "|NAME| thought about it the way you think about something important. \u201cSomewhere nobody has had breakfast before.\u201d"] },
  sea:    { bg:'#4FB3C9', tint:'#E2F3F6', title:'UNDER THE SEA',
    story:["Down where the water turned green,",
           "|NAME| met a fish with a worried face.",
           "\u201cI\u2019ve lost my way home,\u201d said the fish."],
    spread:["Down where the water turned green and quiet, |NAME| met a fish with a very worried face. \u201cI have lost my way home,\u201d said the fish.",
            "\u201cThen we will find it,\u201d said |NAME|, who was six, and who had never once left anybody behind."] },
  jungle: { bg:'#3E9B4F', tint:'#E6F2E7', title:'IN THE JUNGLE',
    story:["The lion had a very large yawn and",
           "a very small problem. \u201cI can\u2019t reach",
           "the tall fruit,\u201d he said."],
    spread:["The lion had a very large yawn and a very small problem. \u201cI cannot reach the tall fruit,\u201d he said, looking up at it sadly.",
            "|NAME| looked at the lion. |NAME| looked at the tree. Then |NAME| had the kind of idea that makes a whole jungle go quiet."] }
};

var K = 'stroke="#17150F" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"';

/* A bold colour motif per world, drawn around (300,300) in a 600-wide box. */
function motif(theme){
  if(theme === 'space'){
    return '<circle cx="140" cy="150" r="52" fill="#FFC53D" '+K+'/>'+
      '<ellipse cx="140" cy="150" rx="86" ry="22" fill="none" '+K+' transform="rotate(-20 140 150)"/>'+
      '<circle cx="470" cy="112" r="30" fill="#FFFDF7" '+K+'/>'+
      '<path d="M300 96c40 40 56 126 50 216H250c-6-90 10-176 50-216Z" fill="#FFFDF7" '+K+'/>'+
      '<path d="M264 178c22-20 50-20 72 0" fill="none" stroke="#17150F" stroke-width="3"/>'+
      '<circle cx="300" cy="212" r="30" fill="#4FB3C9" '+K+'/>'+
      '<path d="M250 256 206 342l44-24Z" fill="#E8452C" '+K+'/>'+
      '<path d="M350 256l44 86-44-24Z" fill="#E8452C" '+K+'/>'+
      '<path d="M272 316c-4 42 20 52 28 84 12-32 34-42 30-84Z" fill="#F58A2E" '+K+'/>'+
      ['70,300','520,260','430,60','96,86','546,180'].map(function(p){var c=p.split(',');
        return '<path d="M'+c[0]+' '+(+c[1]-13)+'l4 9 9 4-9 4-4 9-4-9-9-4 9-4Z" fill="#FFC53D" stroke="#17150F" stroke-width="2.5" stroke-linejoin="round"/>';}).join('');
  }
  if(theme === 'sea'){
    return '<circle cx="96" cy="96" r="20" fill="#FFFDF7" '+K+'/>'+
      '<circle cx="150" cy="52" r="13" fill="#FFFDF7" '+K+'/>'+
      '<circle cx="498" cy="112" r="17" fill="#FFFDF7" '+K+'/>'+
      '<path d="M212 210c58-64 190-64 242 8-52 70-184 70-242 8Z" fill="#F58A2E" '+K+'/>'+
      '<path d="M212 216 140 156l8 118Z" fill="#F58A2E" '+K+'/>'+
      '<path d="M300 150c16-30 46-34 62-16-20 4-34 14-44 30Z" fill="#FFC53D" '+K+'/>'+
      '<circle cx="404" cy="200" r="11" fill="#17150F"/><circle cx="408" cy="196" r="4" fill="#FFFDF7"/>'+
      '<path d="M262 186c12 26 12 48 2 74M296 178c14 28 14 54 2 82" fill="none" stroke="#17150F" stroke-width="3"/>'+
      '<path d="M150 400c0-44 66-44 66 0 0 28-66 28-66 0Z" fill="#7B5EA7" '+K+'/>'+
      '<ellipse cx="183" cy="370" rx="39" ry="34" fill="#7B5EA7" '+K+'/>'+
      '<circle cx="170" cy="366" r="7" fill="#17150F"/><circle cx="196" cy="366" r="7" fill="#17150F"/>'+
      '<path d="M152 406c-18 20-9 50 7 64M168 412c-11 27-2 52 11 64M200 414c5 27 16 46 34 52M216 406c16 16 27 39 23 62" fill="none" '+K+'/>'+
      '<path d="M430 470c-7-58 16-78 7-124" fill="none" stroke="#3E9B4F" stroke-width="9" stroke-linecap="round"/>'+
      '<path d="M472 470c-5-50 11-68 5-104" fill="none" stroke="#3E9B4F" stroke-width="7" stroke-linecap="round"/>';
  }
  if(theme === 'jungle'){
    return '<path d="M60 470c16-114 7-206-7-270" fill="none" stroke="#8B5E34" stroke-width="11" stroke-linecap="round"/>'+
      '<path d="M52 208c-46-34-66-11-64 18 27-20 46-14 64-7Z" fill="#3E9B4F" '+K+'/>'+
      '<path d="M52 206c-16-53-48-59-66-43 30 7 46 23 60 46Z" fill="#3E9B4F" '+K+'/>'+
      '<path d="M64 200c9-53 46-66 66-50-30 9-48 25-59 53Z" fill="#3E9B4F" '+K+'/>'+
      '<path d="M540 470c-16-108-9-192 2-250" fill="none" stroke="#8B5E34" stroke-width="11" stroke-linecap="round"/>'+
      '<path d="M548 220c9-48 41-59 59-46-27 9-43 23-55 48Z" fill="#3E9B4F" '+K+'/>'+
      '<path d="M550 232c41-30 64-7 60 18-25-18-43-14-60-7Z" fill="#3E9B4F" '+K+'/>'+
      '<circle cx="300" cy="250" r="104" fill="#F58A2E" '+K+'/>'+
      Array.from({length:14},function(_,i){var a=i*25.7*Math.PI/180;
        return '<path d="M'+(300+Math.cos(a)*104).toFixed(1)+' '+(250+Math.sin(a)*104).toFixed(1)+
        'Q'+(300+Math.cos(a+0.22)*126).toFixed(1)+' '+(250+Math.sin(a+0.22)*126).toFixed(1)+
        ' '+(300+Math.cos(a)*138).toFixed(1)+' '+(250+Math.sin(a)*138).toFixed(1)+'" fill="none" stroke="#17150F" stroke-width="7" stroke-linecap="round"/>';}).join('')+
      '<circle cx="300" cy="250" r="72" fill="#FFC53D" '+K+'/>'+
      '<circle cx="272" cy="232" r="9" fill="#17150F"/><circle cx="328" cy="232" r="9" fill="#17150F"/>'+
      '<circle cx="276" cy="228" r="3" fill="#FFFDF7"/><circle cx="332" cy="228" r="3" fill="#FFFDF7"/>'+
      '<path d="M286 264h28l-14 15Z" fill="#17150F"/>'+
      '<ellipse cx="282" cy="288" rx="22" ry="17" fill="#FFFDF7" '+K+'/>'+
      '<ellipse cx="318" cy="288" rx="22" ry="17" fill="#FFFDF7" '+K+'/>';
  }
  /* dragon */
  return '<rect x="404" y="196" width="52" height="196" rx="4" fill="#E8452C" '+K+'/>'+
    '<rect x="514" y="196" width="52" height="196" rx="4" fill="#E8452C" '+K+'/>'+
    '<path d="M396 196 430 142 464 196Z" fill="#7B5EA7" '+K+'/>'+
    '<path d="M506 196 540 142 574 196Z" fill="#7B5EA7" '+K+'/>'+
    '<rect x="416" y="240" width="28" height="38" rx="14" fill="#FFFDF7" '+K+'/>'+
    '<rect x="526" y="240" width="28" height="38" rx="14" fill="#FFFDF7" '+K+'/>'+
    '<circle cx="112" cy="104" r="38" fill="#FFC53D" stroke="#17150F" stroke-width="3.5"/>'+
    '<path d="M118 300c-52-7-66-74-37-124 28-46 100-53 140-21 48 38 37 115-9 142Z" fill="#3E9B4F" '+K+'/>'+
    '<path d="M148 402c-58 12-80 48-71 82" fill="none" '+K+'/>'+
    '<path d="M120 406 113 377l30 18Z" fill="#3E9B4F" '+K+'/>'+
    '<ellipse cx="126" cy="416" rx="38" ry="18" fill="#3E9B4F" '+K+'/>'+
    '<ellipse cx="216" cy="418" rx="36" ry="17" fill="#3E9B4F" '+K+'/>'+
    '<path d="M148 174c-18-68 34-110 87-90-25 26-34 57-30 90Z" fill="#FF8FA3" '+K+'/>'+
    '<ellipse cx="222" cy="150" rx="66" ry="57" fill="#3E9B4F" '+K+'/>'+
    '<path d="M277 157c34-11 57 2 57 18s-25 23-55 11Z" fill="#3E9B4F" '+K+'/>'+
    '<circle cx="316" cy="166" r="5" fill="#17150F"/>'+
    '<path d="M199 98 186 52 222 79Z" fill="#FFC53D" '+K+'/>'+
    '<path d="M245 91 261 47 272 85Z" fill="#FFC53D" '+K+'/>'+
    '<circle cx="236" cy="132" r="10" fill="#17150F"/><circle cx="240" cy="128" r="4" fill="#FFFDF7"/>'+
    '<path d="M207 178c11 9 30 9 41 0" fill="none" stroke="#17150F" stroke-width="3"/>';
}

function fitTitle(name, tail){
  var n = (name||'').trim().toUpperCase() || 'YOUR KID';
  var full = n + ' ' + tail;
  if(full.length <= 17) return { lines:[full], size:52 };
  return { lines:[n, tail], size: Math.max(30, Math.min(50, 300 / Math.max(n.length, tail.length) * 3.4)) };
}

/* ---- front cover ---- */
function coverSVG(name, theme, age){
  var c = COVERS[theme] || COVERS.dragon;
  var t = fitTitle(name, c.title);
  var y0 = t.lines.length > 1 ? 118 : 140;
  return '<svg viewBox="0 0 600 780" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Book cover">'+
    '<rect x="10" y="10" width="580" height="760" rx="12" fill="'+c.bg+'" stroke="#17150F" stroke-width="4"/>'+
    '<rect x="46" y="52" width="508" height="'+(t.lines.length>1?150:118)+'" rx="10" fill="#FFFDF7" stroke="#17150F" stroke-width="4"/>'+
    t.lines.map(function(l,i){
      return '<text x="300" y="'+(y0 + i*t.size*1.06)+'" text-anchor="middle" font-family="Baloo 2,sans-serif" '+
             'font-weight="800" font-size="'+t.size+'" fill="#17150F" letter-spacing="1">'+l+'</text>';}).join('')+
    '<g transform="translate(0,266)">'+motif(theme)+'</g>'+
    '<text x="300" y="712" text-anchor="middle" font-family="Baloo 2,sans-serif" font-weight="700" font-size="21" '+
      'fill="'+(theme==='space'?'#FFFDF7':'#17150F')+'" letter-spacing="4">A PAPER STAR BOOK</text>'+
    '<text x="300" y="742" text-anchor="middle" font-family="Karla,sans-serif" font-size="17" '+
      'fill="'+(theme==='space'?'#C9D3EC':'#4A4536')+'">made for '+((name||'').trim()||'your kid')+
      (age?', age '+age:'')+'</text>'+
    '</svg>';
}

/* ---- inside story page ---- */
function storySVG(name, theme, pageNo){
  var c = COVERS[theme] || COVERS.dragon;
  var who = (name||'').trim() || 'Your kid';
  var lines = c.story.map(function(l){ return l.replace(/\|NAME\|/g, who); });
  return '<svg viewBox="0 0 600 780" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Story page">'+
    '<rect x="12" y="12" width="576" height="756" rx="10" fill="#FFFFFF" stroke="#17150F" stroke-width="3"/>'+
    '<rect x="52" y="52" width="496" height="430" rx="10" fill="'+c.tint+'" stroke="#17150F" stroke-width="3.5"/>'+
    '<g transform="translate(0,110) scale(0.82) translate(66,0)">'+motif(theme)+'</g>'+
    lines.map(function(l,i){
      return '<text x="300" y="'+(566 + i*46)+'" text-anchor="middle" font-family="Baloo 2,sans-serif" '+
             'font-weight="600" font-size="30" fill="#17150F">'+l+'</text>';}).join('')+
    '<text x="300" y="736" text-anchor="middle" font-family="Karla,sans-serif" font-size="16" fill="#B6AE9C">'+
      (pageNo||4)+'</text>'+
    '</svg>';
}

/* ---- the same coloring page, already coloured in ---- */
var FILLS = {
  dragon:['#FFC53D','#FFFDF7','#FFFDF7','#E8452C','#E8452C','#E8452C','#7B5EA7','#7B5EA7','#7B5EA7','#FF8FA3','#FF8FA3','#8B5E34','#2563D9','#2563D9','#FF8FA3','#3E9B4F','#3E9B4F','#3E9B4F','#3E9B4F','#3E9B4F','#3E9B4F','#3E9B4F','#3E9B4F','#FFC53D','#FFC53D','#FF8FA3','#FFC53D','#FF8FA3','#FF8FA3','#FF8FA3','#FF8FA3'],
  space:['#FFC53D','#FFC53D','#FFC53D','#FFC53D','#FFC53D','#FFC53D','#FFC53D','#F58A2E','#E8452C','#7B5EA7','#FFFDF7','#FFFDF7','#FFFDF7','#FFFDF7','#FFFDF7','#4FB3C9','#E8452C','#E8452C','#FF8FA3','#F58A2E','#7B5EA7','#7B5EA7'],
  sea:['#FFFDF7','#FFFDF7','#FFFDF7','#FFFDF7','#FFFDF7','#FFFDF7','#F58A2E','#F58A2E','#FFC53D','#FF8FA3','#FF8FA3','#7B5EA7','#7B5EA7','#8B5E34','#FFC53D','#E8452C'],
  jungle:['#FFC53D','#3E9B4F','#3E9B4F','#3E9B4F','#3E9B4F','#3E9B4F','#3E9B4F','#3E9B4F','#3E9B4F','#3E9B4F','#3E9B4F','#3E9B4F','#3E9B4F','#F58A2E','#FFC53D','#FFFDF7','#FFFDF7','#F58A2E','#F58A2E','#8B5E34','#8B5E34']
};
function colouredSVG(name, theme){
  var pal = FILLS[theme] || FILLS.dragon, i = 0;
  var art = (SCENES[theme] || SCENES.dragon).art.replace(/fill="#FFFFFF" class="f"/g, function(){
    return 'fill="' + pal[i++ % pal.length] + '"';
  });
  var t = (possessive(name) + SCENES[theme].title).toUpperCase();
  var fs = t.length>26?25:t.length>20?31:t.length>15?38:44;
  return '<svg viewBox="0 0 600 780" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="A finished page">'+
    '<rect x="12" y="12" width="576" height="756" rx="10" fill="#FFFFFF" stroke="#17150F" stroke-width="3"/>'+
    '<path d="M60 50H540L516 96 540 142H60L84 96Z" fill="#FFC53D" stroke="#17150F" stroke-width="4.5" stroke-linejoin="round"/>'+
    '<text x="300" y="97" text-anchor="middle" dominant-baseline="middle" font-family="Baloo 2,sans-serif" '+
      'font-weight="800" font-size="'+fs+'" fill="#17150F" letter-spacing="1.5">'+t+'</text>'+ art +
    '<text x="300" y="756" text-anchor="middle" font-family="Karla,sans-serif" font-size="15" fill="#B6AE9C" '+
      'letter-spacing="3">PAPER STAR</text></svg>';
}
